export const clientGroupsConstants = {
  SET_CLIENT_GROUPS_LOADING: 'clientGroups/SET_CLIENT_GROUPS_LOADING',
  GET_CLIENT_GROUPS: 'clientGroups/GET_CLIENT_GROUPS',
  SET_CLIENT_GROUPS: 'clientGroups/SET_CLIENT_GROUPS',
  CLEAR_CLIENT_GROUPS: 'clientGroups/CLEAR_CLIENT_GROUPS',
  GET_CLIENT_GROUP: 'clientGroups/GET_CLIENT_GROUP',
  SET_CLIENT_GROUP: 'clientGroups/SET_CLIENT_GROUP',
  ADD_CLIENT_GROUP: 'clientGroups/ADD_CLIENT_GROUP',
  EDIT_CLIENT_GROUP: 'clientGroups/EDIT_CLIENT_GROUP',
  DEACTIVATE_CLIENT_GROUP: 'clientGroups/DEACTIVATE_CLIENT_GROUP',
  SYNC_CLIENT_GROUP: 'clientGroups/SYNC_CLIENT_GROUP',
  EXPORT_CLIENT_GROUPS: 'clientGroups/EXPORT_CLIENT_GROUPS',
};
